import { MChatRiscoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import React from 'react'
import { calculateAge } from 'util/date/calculateAge'

import { MChatRfResultadoView } from '../../components/MChatRfResultadoView'
import { MCHAT_RESULTADOS, MChatRiscoPrevioRelevanteInfoModel, MChatViewModel } from '../model-mchat'
import { MChatEscala } from './MChatEscala'

interface MChatResultadoViewProps {
  value: MChatViewModel
  isInsideModal?: boolean
  showEscala?: boolean
  alertaMChatAnterior?: MChatRiscoPrevioRelevanteInfoModel
  isRegistradoAgora: boolean
}

export function MChatResultadoView(props: MChatResultadoViewProps) {
  const {
    value: { resultado, risco, footerInfo },
    isInsideModal,
    showEscala,
    alertaMChatAnterior,
    isRegistradoAgora,
  } = props

  const {
    atendimentoProfissional: { iniciadoEm: dataAtendimento },
    cidadao: { dataNascimento },
  } = useAtendimentoContext()

  const ageInMonthsResultadoAnterior = footerInfo?.dataResultado
    ? calculateAge(dataNascimento, footerInfo.dataResultado).ageInMonths
    : undefined
  const { ageInMonths } = calculateAge(dataNascimento, dataAtendimento.getTime())
  const deveExibirAlertaRiscoBaixoApos24Meses =
    ageInMonths >= 24 && !isRegistradoAgora && risco === MChatRiscoEnum.BAIXO && ageInMonthsResultadoAnterior < 24

  const { status, title, encaminhamento } = MCHAT_RESULTADOS[risco]

  return (
    <MChatRfResultadoView
      status={status}
      title={title}
      description={encaminhamento(ageInMonths)}
      label={'ponto'.pluralizeAndConcatValue(resultado)}
      content={showEscala && <MChatEscala isInsideModal={isInsideModal} pontuacao={resultado} risco={risco} />}
      footerInfo={footerInfo}
      alertaMChatAnterior={alertaMChatAnterior}
      deveExibirAlertaRiscoBaixoApos24Meses={deveExibirAlertaRiscoBaixoApos24Meses}
    />
  )
}
